 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"attestation":"attestation","attestation-department":"attestation-department","attestation-total":"attestation-total","cooking":"cooking","cooking-restaurant":"cooking-restaurant","cooking-total":"cooking-total","danger":"danger","danger-restaurant":"danger-restaurant","danger-total":"danger-total","dish":"dish","dish-restaurant~dish-total":"dish-restaurant~dish-total","dish-restaurant":"dish-restaurant","dish-total":"dish-total","efficiency":"efficiency","efficiency-restaurant":"efficiency-restaurant","efficiency-total":"efficiency-total","error-401":"error-401","error-404":"error-404","income":"income","income-restaurant~income-total":"income-restaurant~income-total","income-restaurant":"income-restaurant","income-total":"income-total","load":"load","load-restaurant":"load-restaurant","load-total":"load-total","login":"login","news":"news","settings":"settings","settings-comissions":"settings-comissions","settings-income":"settings-income","settings-payments":"settings-payments","settings-timing":"settings-timing","settings-users":"settings-users","settings-wages":"settings-wages","staff":"staff","staff-department":"staff-department","staff-total":"staff-total","timing":"timing","timing-hall":"timing-hall","timing-hall-restaurant~timing-hall-total":"timing-hall-restaurant~timing-hall-total","timing-hall-restaurant":"timing-hall-restaurant","timing-hall-total":"timing-hall-total","timing-restaurant":"timing-restaurant","timing-total":"timing-total","tone":"tone","tone-detail":"tone-detail","trip":"trip","trip-restaurant":"trip-restaurant","trip-total":"trip-total","unit-detail2":"unit-detail2","unit2":"unit2","usage":"usage","usage-restaurant":"usage-restaurant","usage-total":"usage-total"}[chunkId]||chunkId) + "." + {"attestation":"a78424ab","attestation-department":"0973578b","attestation-total":"427d479a","cooking":"2e6da5b3","cooking-restaurant":"4b4b850f","cooking-total":"1d3a3254","danger":"3782ec54","danger-restaurant":"54f9da8d","danger-total":"1e786e57","dish":"0f0d6592","dish-restaurant~dish-total":"a87a69d8","dish-restaurant":"fdd5531f","dish-total":"12090c64","efficiency":"d79083ef","efficiency-restaurant":"f4eb8727","efficiency-total":"9afe4046","error-401":"9c023250","error-404":"df322f3b","income":"8195a6a4","income-restaurant~income-total":"80af3798","income-restaurant":"4b1696ea","income-total":"a491ca34","load":"30591e9a","load-restaurant":"575381ec","load-total":"14e6988c","login":"c352d572","news":"ad48c7aa","settings":"73397035","settings-comissions":"2abb9959","settings-income":"8188d9d0","settings-payments":"4ac48ed8","settings-timing":"2d24c01a","settings-users":"19b9af63","settings-wages":"0dcccc9b","staff":"bc08b4fd","staff-department":"02081b02","staff-total":"84115683","timing":"8b463932","timing-hall":"ec9445ef","timing-hall-restaurant~timing-hall-total":"4e3ed214","timing-hall-restaurant":"a071da9b","timing-hall-total":"295e72ac","timing-restaurant":"2b0f6bf8","timing-total":"b57b4c11","tone":"84e014bc","tone-detail":"695a98ac","trip":"79411e7a","trip-restaurant":"7544160c","trip-total":"d887dc1e","unit-detail2":"a533f286","unit2":"890f6d92","usage":"f84d5a7f","usage-restaurant":"da162118","usage-total":"b0c63a33"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"attestation":1,"attestation-department":1,"attestation-total":1,"cooking-restaurant":1,"cooking-total":1,"danger-restaurant":1,"danger-total":1,"dish-restaurant~dish-total":1,"dish-restaurant":1,"dish-total":1,"efficiency":1,"efficiency-restaurant":1,"efficiency-total":1,"error-401":1,"error-404":1,"income-restaurant~income-total":1,"income-restaurant":1,"income-total":1,"load":1,"load-restaurant":1,"load-total":1,"login":1,"news":1,"settings":1,"settings-comissions":1,"settings-income":1,"settings-payments":1,"settings-timing":1,"settings-users":1,"settings-wages":1,"staff":1,"staff-department":1,"staff-total":1,"timing":1,"timing-hall-restaurant~timing-hall-total":1,"timing-hall-restaurant":1,"timing-hall-total":1,"timing-restaurant":1,"timing-total":1,"tone-detail":1,"trip":1,"trip-restaurant":1,"trip-total":1,"unit-detail2":1,"usage-restaurant":1,"usage-total":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"attestation":"attestation","attestation-department":"attestation-department","attestation-total":"attestation-total","cooking":"cooking","cooking-restaurant":"cooking-restaurant","cooking-total":"cooking-total","danger":"danger","danger-restaurant":"danger-restaurant","danger-total":"danger-total","dish":"dish","dish-restaurant~dish-total":"dish-restaurant~dish-total","dish-restaurant":"dish-restaurant","dish-total":"dish-total","efficiency":"efficiency","efficiency-restaurant":"efficiency-restaurant","efficiency-total":"efficiency-total","error-401":"error-401","error-404":"error-404","income":"income","income-restaurant~income-total":"income-restaurant~income-total","income-restaurant":"income-restaurant","income-total":"income-total","load":"load","load-restaurant":"load-restaurant","load-total":"load-total","login":"login","news":"news","settings":"settings","settings-comissions":"settings-comissions","settings-income":"settings-income","settings-payments":"settings-payments","settings-timing":"settings-timing","settings-users":"settings-users","settings-wages":"settings-wages","staff":"staff","staff-department":"staff-department","staff-total":"staff-total","timing":"timing","timing-hall":"timing-hall","timing-hall-restaurant~timing-hall-total":"timing-hall-restaurant~timing-hall-total","timing-hall-restaurant":"timing-hall-restaurant","timing-hall-total":"timing-hall-total","timing-restaurant":"timing-restaurant","timing-total":"timing-total","tone":"tone","tone-detail":"tone-detail","trip":"trip","trip-restaurant":"trip-restaurant","trip-total":"trip-total","unit-detail2":"unit-detail2","unit2":"unit2","usage":"usage","usage-restaurant":"usage-restaurant","usage-total":"usage-total"}[chunkId]||chunkId) + "." + {"attestation":"48f73317","attestation-department":"5515c236","attestation-total":"279c69df","cooking":"31d6cfe0","cooking-restaurant":"7102f582","cooking-total":"a2705d65","danger":"31d6cfe0","danger-restaurant":"35c8639a","danger-total":"c76f57ae","dish":"31d6cfe0","dish-restaurant~dish-total":"56a19b16","dish-restaurant":"5af6f78c","dish-total":"0d61194d","efficiency":"77c98dc6","efficiency-restaurant":"12f01831","efficiency-total":"101c018f","error-401":"eefffc31","error-404":"d23bfcf7","income":"31d6cfe0","income-restaurant~income-total":"8aa4167f","income-restaurant":"567eb989","income-total":"03793741","load":"ee68fa82","load-restaurant":"a6c7f0d2","load-total":"643156c4","login":"10505a2e","news":"72044459","settings":"45da5b13","settings-comissions":"58d3eb71","settings-income":"e7e6b506","settings-payments":"19a1f462","settings-timing":"8afbd804","settings-users":"4f01b4cb","settings-wages":"c1ed2400","staff":"507eb1c9","staff-department":"abd38105","staff-total":"c219d443","timing":"caf2a5bd","timing-hall":"31d6cfe0","timing-hall-restaurant~timing-hall-total":"7a3bbb3b","timing-hall-restaurant":"f8447bdb","timing-hall-total":"775a01a6","timing-restaurant":"09a15af1","timing-total":"b91244a2","tone":"31d6cfe0","tone-detail":"cfa6f940","trip":"64d3cf4e","trip-restaurant":"fe392bfb","trip-total":"a8f330d7","unit-detail2":"85455ea1","unit2":"31d6cfe0","usage":"31d6cfe0","usage-restaurant":"d2cd5e28","usage-total":"6402f06d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
